<template>
  <!-- 우아한책임 > 준법경영 -->
  <section v-bind="$attrs" :id="hashTitle($t('compliance.declaration.title'))" class="article-anchor esg-compliance">
    <div class="esg-title-wrap">
      <h4 class="esg-title">{{ $t('menuSustainability.compliance') }}</h4>
    </div>

    <!-- 국제표준 규범준수 경영시스템 도입 -->
    <article
      class="esg-box declaration"
    >
      <div class="esg-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="../../../static/image/sustainability/pc/image_compliance.jpg">
            <source media="(max-width: 750px)" srcset="../../../static/image/sustainability/m/image_compliance.jpg">
            <img src="../../../static/image/sustainability/pc/image_compliance.jpg" :alt="$t('compliance.declaration.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('compliance.ISO37301.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('compliance.ISO37301.paragraph')" class="paragraph" />

        <div class="orgchart">
          <div class="orgchart-diagram">
            <div class="item item-1"><span>{{ $t('compliance.ISO37301.orgChart.item1') }}</span></div>
            <div class="item item-2"><span>{{ $t('compliance.ISO37301.orgChart.item2') }}</span></div>
            <div class="item item-3"><span>{{ $t('compliance.ISO37301.orgChart.item3') }}</span></div>
            <div class="item item-4"><span>{{ $t('compliance.ISO37301.orgChart.item4') }}</span></div>
          </div>
        </div>
      </div>
    </article>

    <!-- 자율준수선언문 -->
    <article
      :id="hashTitle($t('compliance.declaration.title'))"
      class="article-anchor esg-box statement"
    >
      <html-view :value="$t('compliance.declaration.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <div class="nav-tabs">
          <button type="button" :class="{active: declaration === 3}" @click="onChangeDeclaration(3)">{{ $t('compliance.declaration.tab3.menu') }}</button>
          <button type="button" :class="{active: declaration === 2}" @click="onChangeDeclaration(2)">{{ $t('compliance.declaration.tab2.menu') }}</button>
          <button type="button" :class="{active: declaration === 1}" @click="onChangeDeclaration(1)">{{ $t('compliance.declaration.tab1.menu') }}</button>
        </div>
        <div v-if="declaration === 3">
          <html-view :value="$t('compliance.declaration.tab3.paragraph')" class="paragraph" />
        </div>
        <div v-if="declaration === 2">
          <html-view :value="$t('compliance.declaration.tab2.paragraph')" class="paragraph" />
        </div>
        <div v-if="declaration === 1">
          <html-view :value="$t('compliance.declaration.tab1.paragraph')" class="paragraph" />
        </div>
        <p class="sign">
          <html-view tag="span" :value="$t('compliance.declaration.sign')" />
          <!--          <span>-->
          <!--            <img-->
          <!--              src="~@/static/image/sign/kimbeomjun.png"-->
          <!--              srcset="~@/static/image/sign/kimbeomjun@2x.png 2x, ~@/static/image/sign/kimbeomjun@3x.png 3x"-->
          <!--              :alt="$t('compliance.declaration.sign')"-->
          <!--            >-->
          <!--          </span>-->
        </p>
      </div>
    </article>

    <!-- 공정거래 자율준수 프로그램 -->
    <article
      :id="hashTitle($t('compliance.program.name'))"
      class="article-anchor esg-box program"
    >
      <div class="esg-box-image">
        <picture>
          <source media="(min-width: 750px)" srcset="../../../static/image/company/pc/image_program.gif">
          <source media="(max-width: 750px)" srcset="../../../static/image/company/m/image_program.gif">
          <img src="../../../static/image/company/pc/image_program.jpg" :alt="$t('compliance.program.name')">
        </picture>
      </div>
      <html-view :value="$t('compliance.program.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('compliance.program.paragraph')" class="paragraph" />
        <div class="standards">
          <p class="standards-title">{{ $t('compliance.program.standards.title') }}</p>
          <ul class="list-number">
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item1') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item2') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item3') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item4') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item5') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item6') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item7') }}</span>
              </p>
            </li>
            <li class="list-number-item">
              <p class="list-number-heading">
                <i class="number" />
                <span>{{ $t('compliance.program.standards.list.item8') }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="orgchart">
          <p class="orgchart-title">{{ $t('compliance.program.orgChart.title') }}</p>
          <div class="orgchart-diagram">
            <div class="item item-1"><span>{{ $t('compliance.program.orgChart.item1') }}</span></div>
            <div class="item item-2"><span>{{ $t('compliance.program.orgChart.item2') }}</span></div>
            <div class="item item-3"><span>{{ $t('compliance.program.orgChart.item3') }}</span></div>
            <div class="item item-4"><span>{{ $t('compliance.program.orgChart.item4') }}</span></div>
            <div class="item item-5"><span>{{ $t('compliance.program.orgChart.item5') }}</span></div>
          </div>
        </div>
      </div>
    </article>

    <!-- 불공정 거래행위 제보하기 -->
    <article
      :id="hashTitle($t('compliance.unfair.name'))"
      class="article-anchor esg-box unfair"
    >
      <div class="esg-box-image">
        <picture>
          <source media="(min-width: 750px)" srcset="../../../static/image/company/pc/image_report@3x.jpg 3x">
          <source media="(max-width: 750px)" srcset="../../../static/image/company/m/image_report@3x.jpg 3x">
          <img src="../../../static/image/company/pc/image_report.jpg" :alt="$t('compliance.unfair.name')">
        </picture>
      </div>
      <html-view :value="$t('compliance.unfair.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('compliance.unfair.paragraph')" class="paragraph" />
        <div>
          <table class="table">
            <colgroup>
              <col style="width:25%">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th>{{ $t('compliance.unfair.table.th1') }}</th>
                <td>
                  <ul class="target-list">
                    <li>{{ $t('compliance.unfair.table.td1.item1') }}</li>
                    <li>{{ $t('compliance.unfair.table.td1.item2') }}</li>
                  </ul>
                </td>
              </tr>
              <tr v-if="$route.params.locale !== 'en'">
                <th>{{ $t('compliance.unfair.table.th2') }}</th>
                <td><router-link :to="{name: 'InformationCenterReport', params: {locale: $route.params.locale}}" class="btn-link">{{ $t('compliance.unfair.table.td2') }}<icon-blank /></router-link></td>
              </tr>
              <tr>
                <th>{{ $t('compliance.unfair.table.th3') }}</th>
                <td><a href="mailto:compliance@woowahan.com">compliance@woowahan.com</a></td>
              </tr>
              <tr>
                <th>{{ $t('compliance.unfair.table.th4') }}</th>
                <td><html-view :value="$t('compliance.unfair.table.td4')" tag="address" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="unfair-box">
          <html-view :value="$t('compliance.unfair.group1.title')" tag="p" class="unfair-box-title" />
          <ul class="unfair-box-list">
            <li>- {{ $t('compliance.unfair.group1.list.item1') }}</li>
            <li>- {{ $t('compliance.unfair.group1.list.item2') }}</li>
          </ul>
        </div>
        <div class="unfair-box">
          <html-view :value="$t('compliance.unfair.group2.title')" tag="p" class="unfair-box-title" />
          <ul class="unfair-box-list">
            <li>- {{ $t('compliance.unfair.group2.list.item1') }}</li>
            <li>- {{ $t('compliance.unfair.group2.list.item2') }}</li>
          </ul>
        </div>
        <div class="unfair-box">
          <html-view :value="$t('compliance.unfair.group3.title')" tag="p" class="unfair-box-title" />
          <ul class="unfair-box-list">
            <li>- {{ $t('compliance.unfair.group3.list.item1') }}</li>
            <li>- {{ $t('compliance.unfair.group3.list.item2') }}</li>
          </ul>
        </div>
      </div>
    </article>
  </section>
</template>
<script>
import { hashTitle } from '@/util'

export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
  data () {
    return {
      declaration: 3,
    }
  },
  methods: {
    hashTitle,
    onChangeDeclaration (index) {
      this.declaration = index
    }
  }
}
</script>
